export const SOCIAL_ECOMM = {
  REQUEST_TEAM_ID: 'social_ecomm/request_team_id',
  RECEIVE_TEAM_ID: 'social_ecomm/receive_team_id',
  RECEIVE_TEAM_ID_ERROR: 'social_ecomm/receive_team_id_error',
  REQUEST_INVITATIONS_AND_TEAM: 'social_ecomm/request_invitations_and_team',
  RECEIVE_INVITATIONS_AND_TEAM: 'social_ecomm/receive_invitations_and_team',
  RECEIVE_INVITATIONS_AND_TEAM_ERROR:
    'social_ecomm/receive_invitations_and_team_error',
  REQUEST_TEAM_AVATARS: 'social_ecomm/request_team_avatars',
  RECEIVE_TEAM_AVATARS: 'social_ecomm/receive_team_avatars',
  RECEIVE_TEAM_AVATARS_ERROR: 'social_ecomm/receive_team_avatars_error',
  CREATE_TEAM: 'social_ecomm/create_team',
  CREATE_TEAM_SUCCESS: 'social_ecomm/create_team_success',
  CREATE_TEAM_ERROR: 'social_ecomm/create_team_error',
  OPEN_INVITE_MODAL: 'social_ecomm/open_invite_modal',
  OPEN_SHARE_INVITE_MODAL: 'social_ecomm/open_share_invite_modal',
  CLOSE_INVITE_MODAL: 'social_ecomm/close_invite_modal',
  REQUEST_TEAM_CARTS: 'social_ecomm/request_team_carts',
  RECEIVE_TEAM_CARTS: 'social_ecomm/receive_team_carts',
  RECEIVE_TEAM_CARTS_ERROR: 'social_comm/receive_team_carts_error',
  REQUEST_WIDGET_DATA: 'social_ecomm/request_widget_data',
};

export function requestTeamId() {
  return {
    type: SOCIAL_ECOMM.REQUEST_TEAM_ID,
  };
}

export function receiveTeamId(team) {
  return {
    type: SOCIAL_ECOMM.RECEIVE_TEAM_ID,
    team,
  };
}

export function receiveTeamIdError(error) {
  return {
    type: SOCIAL_ECOMM.RECEIVE_TEAM_ID_ERROR,
    error,
  };
}

export function requestInvitationsAndTeam() {
  return {
    type: SOCIAL_ECOMM.REQUEST_INVITATIONS_AND_TEAM,
  };
}

export function receiveInvitationsAndTeam(team, redeemedMembers) {
  return {
    type: SOCIAL_ECOMM.RECEIVE_INVITATIONS_AND_TEAM,
    team,
    redeemedMembers,
  };
}

export function receiveInvitationsAndTeamError(error) {
  return {
    type: SOCIAL_ECOMM.RECEIVE_INVITATIONS_AND_TEAM_ERROR,
    error,
  };
}

export function requestTeamAvatars(disableAvatarsFF) {
  return {
    disableAvatarsFF,
    type: SOCIAL_ECOMM.REQUEST_TEAM_AVATARS,
  };
}

export function receiveTeamAvatars(socialAvatars, socialAvatarsIds) {
  return {
    type: SOCIAL_ECOMM.RECEIVE_TEAM_AVATARS,
    socialAvatars,
    socialAvatarsIds,
  };
}

export function receiveTeamAvatarsError(error) {
  return {
    type: SOCIAL_ECOMM.RECEIVE_TEAM_AVATARS_ERROR,
    error,
  };
}

export function createTeam() {
  return {
    type: SOCIAL_ECOMM.CREATE_TEAM,
  };
}

export function createTeamSuccess(team) {
  return {
    type: SOCIAL_ECOMM.CREATE_TEAM_SUCCESS,
    team,
  };
}

export function createTeamError(error) {
  return {
    type: SOCIAL_ECOMM.CREATE_TEAM_ERROR,
    error,
  };
}

export function openInviteModal(experience) {
  return {
    type: SOCIAL_ECOMM.OPEN_INVITE_MODAL,
    experience,
  };
}

export function openShareInviteModal(product, experience) {
  return {
    type: SOCIAL_ECOMM.OPEN_SHARE_INVITE_MODAL,
    product,
    experience,
  };
}

export function closeInviteModal() {
  return {
    type: SOCIAL_ECOMM.CLOSE_INVITE_MODAL,
  };
}

export function requestTeamCarts(socialEcommFF, disableAvatarsFF) {
  return {
    type: SOCIAL_ECOMM.REQUEST_TEAM_CARTS,
    socialEcommFF,
    disableAvatarsFF,
  };
}

export function receiveTeamCarts(
  cartProducts,
  userIds,
  cartVariants,
  socialEcommFF,
  disableAvatarsFF
) {
  return {
    type: SOCIAL_ECOMM.RECEIVE_TEAM_CARTS,
    cartProducts,
    userIds,
    cartVariants,
    socialEcommFF,
    disableAvatarsFF,
  };
}

export function receiveTeamCartsError(error) {
  return {
    type: SOCIAL_ECOMM.RECEIVE_TEAM_CARTS_ERROR,
    error,
  };
}

export function requestWidgetData(socialEcommFF, disableAvatarsFF) {
  return {
    type: SOCIAL_ECOMM.REQUEST_WIDGET_DATA,
    socialEcommFF,
    disableAvatarsFF,
  };
}
